export const envConfig = {
  baseURL: import.meta.env.VITE_API_BASE_URL as string,
  oktaBaseURL: import.meta.env.VITE_OKTA_BASE_URL as string,
  clientId: import.meta.env.VITE_OKTA_CLIENT_ID as string,
  issuer: import.meta.env.VITE_OKTA_ISSUER as string,
  pkce: true,
  redirectUri: import.meta.env.VITE_OKTA_REDIRECT_URI as string,
  scopes: (import.meta.env.VITE_OKTA_SCOPES as string | undefined)?.split(',') || [],
};
